<template>
  <div class="d-flex flex-1 h-100 overflow-hidden">
    <v-card class="report-container w-100 p-0" style="border-radius: 12px; margin-bottom: 24px">
      <v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
        <div class="custom-icon-wrapper">
          <v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
        </div>
        <v-toolbar-title class="size-16 dark-text">{{ $t('res_Title_ManageCounter')}}</v-toolbar-title>
      </v-toolbar>
      <div class="border-top p-4 flex-1 overflow-auto">
        <div class="row justify-space-between m-0 gap-2">
                    <div class="p-0" style="width: 18%">
                        <v-label class="label_required mb-1">{{ $t("res_Label_Category") }}</v-label>
                        <div class="with-absolute-button">
                            <multi-select class="light-bg add-arrow w-100" v-model="categoryId" label="name" track-by="id"
                                open-direction="bottom" :options="applicationsOptions" :searchable="false" 
                                :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                :max-height="1000" :show-no-results="false" :hide-selected="false" :multiple="false"
                                :placeholder="$t('res_Label_Select')">
                            </multi-select>
                        </div>
                    </div>
                    <div class="p-0" style="width: 23%">
                        <v-label class="label_required mb-1">{{ $t("res_Label_SelectCompany") }}</v-label>
                        <div class="with-absolute-button">
                            <multi-select class="light-bg add-arrow w-100" v-model="companyId" label="name" track-by="id"
                                open-direction="bottom" :options="company_items" :searchable="true" @input="onCompanySearch"
                                :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                :max-height="1000" :show-no-results="false" :hide-selected="false" :multiple="false"
                                :placeholder="$t('res_Label_Select')">
                            </multi-select>
                        </div>
                    </div>
                    <div class="p-0" style="width: 23%">
                        <label class="label_required mb-1">{{ $t("res_Label_Structure") }}</label>
                        <StructureUserSelector class=" w-100" :showInternalUsers="false" :showExternalUsers="false"
                            :showInternalStructures="true" :showExternalStructures="false" :isMultiple="false" :isSubscribedEntitiesEnable="this.constants.client_version_Id == 'DEG' && true"
                            :selectedStructureUser="structureId" :disableOtherInternalEntitiesAsExternal="true"
                            @structureUserSelectChanged="structureUserSelectChanged"
                            :addressBook_header="$t('res_Label_SelectStrucutre')">
                        </StructureUserSelector>
                    </div>
                    <div class="p-0" style="width: 28%">
                        <label class="label_required mb-1">{{ $t("res_MenuItems_ChooseTemplate") }}</label>
                        <multi-select class="light-bg add-arrow w-100" v-model="templateId" label="text" track-by="id"
                            open-direction="bottom" :options="templates_items" :searchable="true" 
                            :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                            :max-height="1000" :show-no-results="false" :hide-selected="false" :multiple="false"
                            :placeholder="$t('res_Label_Select')">
                        </multi-select>
                    </div>
                </div>
                <v-row>
                    <div class="d-flex justify-space-between align-items-center ">
                        <v-checkbox class="m-0" v-model="byPdf" :label="byPdfLabel"></v-checkbox>
                        <div class="d-flex gap-2">
                            <v-btn @click="clear()" width="100px" color="mx-2 light-blue">{{ $t("res_ButtonText_Clear") }}</v-btn>
                            <v-btn @click="fetchData()" width="100px" color="primary">{{ $t("res_ButtonText_Search") }}</v-btn>
                            <v-btn @click="addRefrenceCount" width="100px" color="mx-2 primary">{{ $t("res_ButtonText_Add") }}</v-btn>
                        </div>
                    </div>
                </v-row>
                <hr>       
        <v-data-table :headers="headers" :items="displayedItems"  item-key="id" disable-sort hide-default-footer class="elevation-1"
            :items-per-page="displayedItems.length">
          <template v-slot:item="row">
            <tr>
              <td>{{ row.item.name }}</td>
              <td>{{ row.item.value }} </td>
              <td>{{ row.item.category }}</td>
              <td>{{ row.item.company }}</td>
              <td>{{ row.item.structure }} </td>
              <td>{{ row.item.template }}</td>
              <td>{{ row.item.active == true ? $t("res_Label_True") : $t("res_Label_False") }} </td>
              <td>{{ row.item.resetByYear == true ? $t("res_Label_True") : $t("res_Label_False") }} </td>
              <td>{{ row.item.byPdf == true ? $t("res_Label_True") : $t("res_Label_False") }} </td>
              <td class="text-start">
                <div class="onhover-display">
                  <div class="custom-icon-wrapper">
                    <v-icon small @click="editRefernceCounterDialog(row.item)" v-tooltip="'Edit'">custom-icon white-bg edit-icon</v-icon>
                  </div>
                  <div class="custom-icon-wrapper">
                    <v-icon small @click="deleteRefernceCounter(row.item.id)" v-tooltip="'Delete'" >custom-icon white-bg delete-icon</v-icon>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>      
      </div>
    </v-card>

    <v-dialog v-model="openDialog" max-width="500px">
          <v-card>
            <v-card-title>{{ !isEditing ? $t('res_ButtonText_Add') : $t('res_ButtonText_Edit')}}</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <v-label>{{ $t("res_Label_SelectCategory") }} *</v-label>
                  <multi-select class="light-bg add-arrow" v-model="editedItem.categoryId" label="name" track-by="id"
                  open-direction="bottom"  :options="applicationsOptions" :searchable="false" :loading="loading"
                  :internal-search="false" :clear-on-select="false" :close-on-select="true"
                  :options-limit="300" :max-height="1000" :show-no-results="false" :hide-selected="false"
                  :multiple="false" :placeholder="$t('res_Label_Select')">
                </multi-select>
              </v-col>
                <v-col cols="6">
                  <v-label>{{ $t("res_Label_SelectCompany") }} </v-label>
                  <multi-select class="light-bg add-arrow" v-model="editedItem.companyId" label="name" track-by="id"
                  open-direction="bottom" :options="company_items" :searchable="true" :loading="loading" @input="onCompanyUpdate"
                  :internal-search="true" :clear-on-select="false" :close-on-select="true"
                  :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="false"
                  :multiple="false" :placeholder="$t('res_Label_Select')">
                </multi-select>
              </v-col>
            <v-col cols="6">
                <v-label>{{ $t("res_Label_Structure") }} </v-label>
                <StructureUserSelector  :showInternalUsers="false" :showExternalUsers="false"
                    :showInternalStructures="true"
                    :showExternalStructures="false" 
                    :isMultiple="false" :selectedStructureUser="editedItem.structureId"
                    :disableOtherInternalEntitiesAsExternal="true"
                    @structureUserSelectChanged="structureUserSelectUpdate" :addressBook_header="$t('res_Label_SelectStructure')">
                </StructureUserSelector>
            </v-col>
            <v-col cols="6">
                <v-label>{{ $t("res_MenuItems_ChooseTemplate") }} </v-label>
                <multi-select class="light-bg add-arrow" v-model="editedItem.templateId" label="text" track-by="id"
                    open-direction="bottom" :options="templates_items" :searchable="false" :loading="loading"
                    :internal-search="false" :clear-on-select="false" :close-on-select="true"
                    :options-limit="300" :max-height="1000" :show-no-results="false" :hide-selected="false"
                    :multiple="false" :placeholder="$t('res_Label_Select')">
                </multi-select>
              </v-col>
                <v-col cols="6">
                  <v-label>{{ $t("res_Label_Name") }}*</v-label>
                  <v-text-field v-model="editedItem.name" label="" solo></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-label>{{ $t("res_Label_Value") }}*</v-label>
                  <v-text-field type="number" v-model="editedItem.value" label="" solo></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-checkbox v-model="editedItem.active" :label="$t('res_CheckBox_Active')" solo></v-checkbox>
                </v-col>
                <v-col cols="4">
                  <v-checkbox v-model="editedItem.resetByYear" :label="$t('res_CheckBox_ResetByYear')" solo></v-checkbox>
                </v-col>
                <v-col cols="4">
                  <v-checkbox v-model="editedItem.byPdf"  :label="$t('res_CheckBox_ByPdf')" solo></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="gap-2 sticky-actions">
              <v-btn class="primary" style="min-width: 100px !important;" @click="UpdateRefernceCounter()">{{ !isEditing ? $t('res_ButtonText_Add') : $t('res_ButtonText_Edit')}}</v-btn>
              <v-btn  class="light-blue" style="min-width: 100px !important;" @click="openDialog = false">{{ $t("res_ButtonText_Close") }}</v-btn>
            </v-card-actions>
          </v-card>               
    </v-dialog>
  </div>

  
</template>

<script>
import axios from "axios";
import constants from "@/assets/js/constants.js";
import router from '../../router/index.js';
import MultiSelect from 'vue-multiselect';
import StructureUserSelector from '@/components/StructureUserSelector.vue';

export default {
  components: { MultiSelect,StructureUserSelector },
  data() {
    return {
      constants: constants,
      language: '',
      isEditing: true,
      editedItem: {
        id: 0,
        name : "",
        value: null,
        active: false,
        resetByYear : false,
        companyId:null,
        structureId: null,
        templateId:{},
        categoryId :null,
        byPdf:false
      },
      openDialog: false,
      headers: [
        { text: this.$t("res_Label_Name"), value: "name", align: "start", width: "10%" },
        { text: this.$t("res_Label_Value"), value: "value", align: "start", width: "10%" },
        { text: this.$t("res_Label_Category"), value: "category", align: "start", width: "15%"},
        { text: this.$t("res_Label_Company"), value: "company", align: "start", width: "15%"},
        { text: this.$t("res_Label_Structure"), value: "structure", align: "start", width: "15%"},
        { text: this.$t("res_Label_Template"), value: "template", align: "start", width: "15%"},
        { text: this.$t("res_Label_Active"), value: "active", align: "start", width: "10%" },
        { text: this.$t("res_Label_ResetByYear"), value: "resetByYear", align: "start", width: "10%" },        
        { text: this.$t("res_Label_ByPdf"), value: "byPdf", align: "start", width: "15%" },
        { text: this.$t("res_Label_Actions"), value: "actions", align: "start", width: "10%" },

      ],
      displayedItems: [],
      company_items: [],
      templates_items:[],
      category_items:[],
      structure_items:[],
      loading: false,
      categoryId: null,
      applicationsOptions: [],
      companyId: null,
      templateId: null,
      byPdf: false,
      byPdfLabel: '',
      structureId: null,
    };
  },
  methods: {
    clear() {
      this.categoryId = null;
      this.structureId = null;
      this.companyId = null;
      this.templateId = null;
      this.byPdf = false;
      this.fetchData();
    },
    backToAdminPage() {
      router.push({ name: 'admin' });
    },
    getCompaniesForUser() {
      axios.get(constants.baseApiUrl + "Admin/GetCompaniesForUser")
        .then((res) => {
          // Correct the filter logic and fix assignment (=) to comparison (===)
          this.company_items = res.data
            .filter(x => x.external === false); // Use filter instead of where, and ===
        })
        .catch((err) => console.warn(err));
    },
    fetchTemplates(categoryId = 0, structureId = 0) {
      window.showLoading()
      axios.get(constants.baseApiUrl + `Admin/GetAllFilteredTemplates?categoryId=${categoryId}&structureId=${structureId}`)
        .then((res) => {
            this.templates_items = res.data;
            window.hideLoading();
        })
        .catch((err) => console.warn(err))
        .finally(() => window.hideLoading());
    },
    async getAllCategory() {
      try {
        const response = await axios.get(
          constants.baseApiUrl + "Admin/GetAllCategory?isDecreeEnabled="+constants.isDecreeEnabled+"&isCircularEnabled="+constants.isCircularEnabled
        );
        const responseData = response.data;
        for (let i = 0; i < responseData.length; i++) {
          const category = {
            id: responseData[i].id,
            name: responseData[i].name,
          };
          this.category_items.push(category);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    
    structureUserSelectChanged(item) {
      this.structureId = item;
      this.companyId = null;
      this.fetchTemplates(this.categoryId == null ? 0 : this.categoryId.id, item == null ? 0 : item.id);
    },
    structureUserSelectUpdate(item)
    {
      this.editedItem.structureId = item;
      this.editedItem.companyId = null;
      this.fetchTemplates(this.editedItem.categoryId == null ? 0 : this.editedItem.categoryId.id, item == null ? 0 : item.id);
    },
    editRefernceCounterDialog(item) {
      console.log(item);
      this.editedItem = { 
        id: item.id,
        active : item.active,
        resetByYear : item.resetByYear,
        byPdf : item.byPdf,
        name :item.name,
        value : item.value,
        categoryId: this.category_items.find( x => x.id == item.categoryId),
        templateId: this.templates_items.find( x=> x.id == item.templateId),
        companyId: this.company_items.find( x=> x.id == item.companyId),
        structureId: {id:  item.structureId, name: item.structure, isUser: false}
      }; 
      this.isEditing = true; 
      this.openDialog = true;
    },
    resetDataForm() {
      this.editedItem.name = null;
      this.editedItem.active = false;
      this.editedItem.value = null;
      this.editedItem.resetByYear = false;
      this.editedItem.byPdf = false;
      this.editedItem.categoryId=null;
      this.editedItem.structureId=null;
      this.editedItem.companyId=null;
      this.editedItem.templateId=null;
      this.isEditing = false;
    },
    addRefrenceCount() {
      this.isEditing = false;
      this.openDialog = true;
      this.resetDataForm();
    },
    addNewItem()
    {
      if (this.editedItem.categoryId == null || this.editedItem.value == null  || this.editedItem.name == null)
      {
        return window.showAlert('res_Msgs_FillRequired', 'error');
      }

      //this.editedItem.structureId = this.editedItem.structureId ? this.editedItem.structureId.id: this.editedItem.structureId = null;
      this.editedItem.companyId = this.editedItem.companyId ? this.editedItem.companyId.id: this.editedItem.companyId = null;
      this.editedItem.templateId = this.editedItem.templateId ? this.editedItem.templateId.id: this.editedItem.templateId = null;
      this.editedItem.categoryId = this.editedItem.categoryId.id,
      this.editedItem.structureId =  this.editedItem.structureId == null ? null : this.editedItem.structureId.id,

      axios.post(constants.baseApiUrl + 'Admin/AddReferenceCounter' , this.editedItem )
        .then((res) => {
          if (res == undefined || res.data == null )
            window.showAlert('res_Msgs_ErrorOccured', 'error');
          else {
            window.showAlert('res_Msgs_AddRefernceCounter', 'success');
            this.fetchData();
            this.openDialog=false;
            this.resetDataForm();
          }
          window.hideLoading();
        })
        .catch(err => {
          this.handleError(err);
          window.hideLoading();
        })
        .finally(() => window.hideLoading());
    },
    async fetchData() {
      try {
        window.showLoading();
        const requestData = {
          categoryId: this.categoryId == null ? null : this.categoryId.id,
          CompanyId: this.companyId == null ? null : this.companyId.id,
          StructureId: this.structureId == null ? null : this.structureId.id,
          TemplateId: this.templateId == null ? null : this.templateId.id,
          ByPdf: this.byPdf
        };
        const res = await axios.get(constants.baseApiUrl + 'Admin/GetReferenceCounter', { params: requestData }, { headers: constants.headers });
        this.displayedItems = res.data;
        window.hideLoading();
      } catch (error) {
        console.log(error)
      }
      finally {
        window.hideLoading();
      }
    },
    UpdateRefernceCounter() {
      var editNewReference = {
        Active: this.editedItem.active,
        ResetByYear: this.editedItem.resetByYear,
        ByPdf :this.editedItem.byPdf,
        Name : this.editedItem.name,
        Value : this.editedItem.value,
        CompanyId: this.editedItem.companyId == null ? null : this.editedItem.companyId.id,
        StructureId:  this.editedItem.structureId?.id || null
      };
      if(this.isEditing){
        axios.post(constants.baseApiUrl + 'Admin/UpdateReferenceCounters/' + this.editedItem.id, editNewReference,{ headers: constants.headers })
        .then((res) => {
          if (res == undefined || res.data == null) {
            window.showAlert('res_Msgs_ErrorOccured', 'error');
          } else {
            window.showAlert('res_Msgs_RefernceCountUpdated', 'success');
            this.fetchData();
            this.openDialog = false;
            this.resetDataForm();
          }
          window.hideLoading();
        })
        .catch(err => {
          this.handleError(err);
          window.hideLoading();
        })
        .finally(() => window.hideLoading());
      } else if(!this.isEditing) {
        this.addNewItem(); 
      }
    },
    onCompanySearch(value)
    {
      this.displayedItems = [];
      this.structureId = null;
      this.fetchTemplates(this.categoryId == null ? 0 : this.categoryId.id, value == null ? 0 : value.id);
    },
    onCompanyUpdate(value)
    {
        this.editedItem.structureId = null;
        this.fetchTemplates(this.editedItem.categoryId == null ? 0 : this.editedItem.categoryId.id, value == null ? 0 : value.id);
    },
    deleteRefernceCounter(id) {
      window.showInformation('res_Msgs_Confirmation', ('res_Msgs_CategoryRefernceDeleteConfirmation'),
        () => {
          axios.delete(constants.baseApiUrl + 'Admin/DeleteReferenceCounter/' + id)
            .then((res) => {
              window.showAlert('res_Msgs_RefernceCountDeleted' ,'success');
              this.fetchData();
            })
            .catch((err) => {
              console.log(err);
            });
        },
        () => {}
      );
    },
    fetchTypes() {
      window.showLoading()
      axios.get(constants.baseApiUrl + "Admin/GetAllCategory?isDecreeEnabled="+constants.isDecreeEnabled+"&isCircularEnabled="+constants.isCircularEnabled)
      .then(response => 
      {
        const responseData = response.data;
        if(this.language == 'en') {
            for (let i = 0; i < responseData.length; i++) {
                const category = { id: responseData[i].id,  name: responseData[i].name };
                this.applicationsOptions.push(category);
            }
        } else {
            for (let i = 0; i < responseData.length; i++) {
                const category = { id: responseData[i].id,  name: responseData[i].nameAr };
                this.applicationsOptions.push(category);
            }
        }
        window.hideLoading();
      }) 
    .catch((err) => console.warn(err))
    .finally(() => window.hideLoading());   
    },
  },
  mounted() {
    this.fetchData();
    this.fetchTypes();
    this.getCompaniesForUser();
    this.fetchTemplates();
    this.getAllCategory();
    this.language = localStorage.getItem('lang');
    this.byPdfLabel = window.translate("res_CheckBox_ByPdf");
  },
  watch: {
      categoryId: function (newval,OldVal) {
          if(newVal != null)
          {
            var companyOrStructure = this.companyId == null ? this.structureId == null ? 0 : 
              this.structureId.id : this.companyId.id;
            this.fetchTemplates(newval == null ? 0 : newval.id, companyOrStructure);
          }
      },
      'editedItem.categoryId': function (newval,OldVal) {
          if(newVal != null)
          {
            var companyOrStructure = this.editedItem.companyId == null ? (this.editedItem.structureId?.id ?? 0) : this.editedItem.companyId.id;
            this.fetchTemplates(newval == null ? 0 : newval.id, companyOrStructure);
          }
      },
  }
}
</script>

<style scoped>
.v-card__title { align-items: normal; }
.margin-left {
  margin-left: 25px;
}
</style>
